import React, { useState } from "react";
import LoginForm from "@components/Login";
import Traductor from "@utils/traductor";
import { useNavigate } from "react-router-dom";
import { LANGUAGE } from "@/constants";
import * as auth from "@utils/auth";
import { PATHS } from "@/constants";
import { DataSource } from "@factory/DataSource";
import { useGlobalContextUpdate } from "@contexts/Global";
import { validPasswordValidator, validEmailValidator } from "@utils/validator";
const traductor = new Traductor(LANGUAGE);
const api = DataSource(auth.getEnv());

const labels = {
  password: traductor.translate("password"),
  username: traductor.translate("username"),
  email: traductor.translate("email"),
  invalidPassword: traductor.translate("invalidPassword"),
  invalidEmail: traductor.translate("invalidEmail"),
  login: traductor.translate("login"),
};

const Login = () => {
  const [validity, setFieldValidity] = useState({
    email: false,
    password: false,
  });
  const setGlobalContext = useGlobalContextUpdate();
  const navigate = useNavigate();

  const handleSubmit = async ({ email = "", password = "" }) => {
    setGlobalContext({ showOverlay: true });
    try {
      const {
        ok = true,
        error = null,
        result = {},
      } = await api.login({ email, clave: password });
      if (ok && result.success) {
        const { usuario: data = [] } = result;
        const [user] = data;
        const {
          _id: id,
          multiples_mesas = false,
          nombre: name = "",
          mesa: table = "",
          puesto: place,
          puesto_id: placeId = "",
          check_mesas: tables,
        } = user;
        auth.saveToken({ email, name });
        setGlobalContext({
          showOverlay: false,
          data: {
            hasMultiplesTables: multiples_mesas,
            tables,
            email,
            id,
            name,
            table,
            place,
            placeId,
            currentTable: tables[0],
          },
        });
        return navigate(PATHS.DASHBOARD);
      }
      setGlobalContext({
        showOverlay: false,
        showNotification: true,
        notificationType: "error",
        notificationMessage:
          result.errMsg || traductor.translate("loginFailed"),
      });
      console.error(error || result);
    } finally {
      // request done
    }
  };

  const handleFieldValidation = ({ field = "", value = "" }) => {
    // validate field
    const isEmail = field === "email";
    const isPassword = field === "password";
    if (isEmail) {
      const isValidEmail = validEmailValidator(value);
      setFieldValidity({ ...validity, email: isValidEmail });
    }
    if (isPassword) {
      const isValidPassword = validPasswordValidator(value);
      setFieldValidity({ ...validity, password: isValidPassword });
    }
  };

  return (
    <LoginForm
      validity={validity}
      labels={labels}
      onValidate={handleFieldValidation}
      onSubmit={handleSubmit}
    />
  );
};

export default Login;
